module.exports = {"140108001":"尖草坪街道","140108002":"光社街道","140108003":"上兰街道","140108004":"南寨街道","140108005":"迎新街道","140108006":"古城街道","140108007":"汇丰街道","140108008":"柴村街道","140108009":"新城街道","140108100":"向阳镇","140108101":"阳曲镇","140108200":"马头水乡","140108201":"柏板乡","140108202":"西焉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140108.json
// module id = 233
// module chunks = 0